import React, {useContext, useState} from 'react'
import { Divider, Button } from "antd";
import {Table} from "react-bootstrap";
import RecipeItemListHeaders from "./RecipeItemListHeaders";
import RecipeItemListRows from "./RecipeItemListRows";
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItems = () => {
    const [startReading, setStartReading] = useState(false)
    const [rowCount, setRowCount] = useState(0)

    const {rowData} = useContext(RecipeConText)
    const [rowState, setRowState] = rowData

    const handleNewRow = () => {
        const obj = {parity: 1, quantity: 1}
        let mockRows = Object.assign({}, rowState)
        mockRows[rowCount] = obj
        setRowState(mockRows)
        setRowCount(rowCount + 1)
        setStartReading(true)
    }

    return (
        <React.Fragment>
            <h3>Malzeme Listesi</h3>
            <Divider/>
            <Button
                type={'link'}
                style={{marginBottom: '16px'}}
                onClick={handleNewRow}
            >
                Yeni Ekle
            </Button>
            <Table
                className={'recipe-table'}
                responsive
            >
                <thead>
                <tr>
                    <RecipeItemListHeaders/>
                </tr>
                </thead>
                <tbody>

                {
                    startReading ?
                        Object.keys(rowState).map((key,index) => {
                            let item = rowData[key]
                            return <RecipeItemListRows key={key} id={key} row={item} rowCount={index}/>
                        }) : null
                }
                </tbody>
            </Table>
        </React.Fragment>
    )
}
export default RecipeItems